module.exports = __webpack_public_path__ + "static/media/hs_21.97105881.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/heads/JPEG/hs_21.jpg
// module id = 5952
// module chunks = 0